import React, { Component } from "react";
import ReactSelect from "react-select";
import "react-select/dist/react-select.css";
import { filter } from "lodash";

export default class Select extends Component {
  state = { isSelectFocused: false };
  componentDidMount() {
    document.addEventListener("click", this.handleClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
  }
  handleClick = event => {
    if (this.select) {
      if (this.select.contains(event.target)) {
        this.setState({ isSelectFocused: true });
      } else {
        this.setState({ isSelectFocused: false });
      }
    }
  };
  render() {
    const { isSelectFocused } = this.state;
    const {
      label,
      error,
      info,
      selected,
      onChange,
      options,
      clearable,
      searchable,
      placeholder,
      multi,
      readOnly
    } = this.props;
    let _classes = ["form-group", "form-group-custom", "form-control-clear"];
    if (isSelectFocused) {
      _classes.push("active");
    }
    if (!label) {
      _classes.push("form-control-clear-no-head");
    }
    if (!options) {
      return null;
    }

    return (
      <div
        className={_classes.join(" ")}
        ref={element => (this.select = element)}
      >
        {label ? <label>{label}</label> : null}
        <div className="form-control-clear-wrap">
          <ReactSelect
            value={
              multi
                ? selected.length === 0
                  ? [{ label: `Doesn't Matter`, value: -1 }]
                  : selected
                : selected
            }
            onChange={values => {
              if (multi) {
                onChange(filter(values, item => item.value !== -1));
              } else {
                onChange(values);
              }
            }}
            options={options}
            clearable={clearable}
            searchable={searchable}
            placeholder={placeholder}
            multi={multi}
            disabled={readOnly}
          />
        </div>
        {error ? (
          <span className="help-block">{error}</span>
        ) : info ? (
          <span className="help-block">{info}</span>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Select/index.js